"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Search = void 0;
var component_fields_1 = require("@doordash/component-fields");
var component_loading_1 = __importDefault(require("@doordash/component-loading"));
var design_language_1 = require("@doordash/design-language");
var lodash_1 = require("lodash");
var React = __importStar(require("react"));
exports.Search = function (_a) {
    var label = _a.label, _b = _a.isLabelHidden, isLabelHidden = _b === void 0 ? false : _b, _c = _a.hideResultsOnBlur, hideResultsOnBlur = _c === void 0 ? true : _c, _d = _a.placeholder, placeholder = _d === void 0 ? 'Search' : _d, onSearch = _a.onSearch, onResults = _a.onResults, _e = _a.minimumResultCharLength, minimumResultCharLength = _e === void 0 ? 2 : _e, _f = _a.debounceSensitivity, debounceSensitivity = _f === void 0 ? 400 : _f;
    var _g = React.useState(''), searchTerm = _g[0], setSearchTerm = _g[1];
    var _h = React.useState([]), searchResults = _h[0], setSearchResults = _h[1];
    var _j = React.useState(true), showResults = _j[0], setShowResults = _j[1];
    var _k = React.useState(''), error = _k[0], setError = _k[1];
    React.useEffect(function () {
        if (searchTerm.length >= minimumResultCharLength) {
            searchPromise();
        }
    }, [searchTerm]);
    var searchPromise = lodash_1.debounce(function () { return __awaiter(void 0, void 0, void 0, function () {
        var results, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, onSearch(searchTerm)];
                case 1:
                    results = _a.sent();
                    if (!results || results.length === 0) {
                        setError('No results.');
                    }
                    else {
                        setError('');
                    }
                    setSearchResults(results);
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    setError(e_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, debounceSensitivity, { trailing: true });
    var onFocus = function () {
        if (hideResultsOnBlur && searchResults && searchResults.length > 0) {
            setShowResults(true);
        }
    };
    var onBlur = function () {
        if (hideResultsOnBlur && searchResults && searchResults.length > 0) {
            setShowResults(false);
        }
    };
    var shouldShowResults = function () {
        if (hideResultsOnBlur) {
            return searchTerm.length >= minimumResultCharLength &&
                searchResults.length > 0 &&
                showResults;
        }
        return searchTerm.length >= minimumResultCharLength &&
            searchResults.length > 0;
    };
    var shouldShowSearchLoading = searchTerm.length >= minimumResultCharLength &&
        error.length === 0 &&
        searchResults.length === 0;
    return (React.createElement(React.Fragment, null,
        React.createElement(component_fields_1.SearchField, { autoComplete: "off", label: label, isLabelHidden: isLabelHidden, value: searchTerm, onFocus: onFocus, onBlur: onBlur, onChange: function (newTerm) {
                if ((newTerm.length === 0 || searchTerm.length > newTerm.length) &&
                    searchResults.length > 0) {
                    setSearchResults([]);
                }
                setError('');
                setSearchTerm(newTerm);
            }, placeholder: placeholder, error: error }),
        shouldShowSearchLoading && (React.createElement(React.Fragment, null,
            React.createElement(design_language_1.Stack, { size: design_language_1.Stack.Sizes.Medium }),
            React.createElement(component_loading_1["default"], null))),
        shouldShowResults() && (
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        React.createElement("div", { onMouseDown: function (e) { return e.preventDefault(); } }, onResults(searchResults)))));
};
exports["default"] = exports.Search;
